import type { FilterStore } from '@promoboxx/use-filter/store/index'
// @ts-expect-error
import qs from 'qs'

import historyRef from './history'

// Copied from ...
// https://github.com/promoboxx/use-filter/blob/eef98a0d742389e64a31da4ac5d28f3303e463c7/src/store/urlParamStore.ts
// ... but using react-router history instead of native browser API in
// `replaceQueryParams`.

const createUrlParamStore = () => {
  const urlParamStore: FilterStore = {
    getFilter(namespace) {
      const parsed = naivelyParseExistingParams()

      const parsedInfo = parsed[`info.${namespace}`]
      const parsedFilter = parsed[`filter.${namespace}`]

      // useFilter doesn't really support returning a partial FilterInfo, so both
      // need to be present,
      if (parsedInfo || parsedFilter) {
        const { page, offset, pageSize, ...rest } = parsedInfo || {}

        return {
          ...{
            // cast string to number or undefined
            page: 1 / page ? +page : undefined,
            pageSize: 1 / pageSize ? +pageSize : undefined,
            offset: 1 / offset ? +offset : undefined,
            ...rest,
          },
          filter: parsedFilter,
        }
      }
    },

    saveFilter(namespace, filterInfo) {
      const parsed = naivelyParseExistingParams()

      // Setting the params to the equivalent of { [namespace]: filterInfo }
      // takes up more room. The idea is that this ...
      //     filter.filterName%5BfilterValueKey%5D=filterValueValue
      // ... is smaller than ...
      //     filterName%5Bfilter%5D%5BfilterValueKey%5D=filterValueValue
      // ... by 5 characters per value in a filter. So excuse us for a second ...
      const clonedInfo: Partial<typeof filterInfo> = { ...filterInfo }
      const clonedFilter = filterInfo.filter
      delete clonedInfo.filter
      delete clonedInfo.lastRefreshAt
      delete clonedInfo.shouldRunImmediately
      delete clonedInfo.totalResults
      delete clonedInfo.totalPages
      delete clonedInfo.nextCursor
      parsed[`filter.${namespace}`] = clonedFilter
      parsed[`info.${namespace}`] = clonedInfo

      replaceQueryParams(qs.stringify(parsed))
    },

    clear() {
      const parsed = naivelyParseExistingParams()

      for (const key in parsed) {
        if (key.startsWith('filter.') || key.startsWith('info.')) {
          delete parsed[key]
        }
      }

      replaceQueryParams(qs.stringify(parsed))
    },

    getData() {
      return undefined
    },
    saveData() {},
  }

  return urlParamStore
}

function replaceQueryParams(newParams: string) {
  const nextUrl = new URL(window.location.toString())
  nextUrl.search = newParams

  historyRef
    .instance()
    .replace(`${nextUrl.pathname}${nextUrl.search}${nextUrl.hash}`)
}

function naivelyParseExistingParams() {
  // Don't really want to do any casting, especially not to `any`, but the type
  // of `qs.parse` is so wide we'd have to litter checks all over the place.
  return qs.parse(window.location.search.substring(1)) as any
}

export default createUrlParamStore()
